import { render, staticRenderFns } from "./UsersViewCollections.vue?vue&type=template&id=079965ef&lang=pug&"
import script from "./UsersViewCollections.vue?vue&type=script&lang=js&"
export * from "./UsersViewCollections.vue?vue&type=script&lang=js&"
import style0 from "./UsersViewCollections.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports